export default __webpack_public_path__ + "static/media/empty.5e0171d4.svg";